import type { InputHTMLAttributes } from 'react';

export interface VeldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  /** Uitleg of foutmelding onder het veld, in gewone taal. */
  toelichting?: string | null;
  fout?: boolean;
}

export function Veld({ label, toelichting, fout = false, className = '', ...rest }: VeldProps) {
  return (
    <label className="block">
      <span className="mb-1 block text-base text-tekst-zacht">{label}</span>
      <input
        className={`min-h-14 w-full rounded-tegel border bg-vlak px-4 text-lg text-tekst ${
          fout ? 'border-fout' : 'border-rand'
        } ${className}`}
        {...rest}
      />
      {toelichting != null && toelichting !== '' && (
        <span className={`mt-1 block text-base ${fout ? 'text-fout' : 'text-tekst-zacht'}`}>
          {toelichting}
        </span>
      )}
    </label>
  );
}
